// extracted by mini-css-extract-plugin
export default {"copy":"TrialExtendModal_copy__19fU-","bold":"TrialExtendModal_bold__ShWYH","options":"TrialExtendModal_options__Tr+x-","option":"TrialExtendModal_option__slMLW"};